import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { req_list_ccw_haviorLog, req_add_ccw_haviorLog, req_delete_ccw_haviorLog_discuss } from '../../api'
import { formateDate } from '../../utils/dateUtil'
import { Card, Form, Input, Button, Divider } from 'antd'

const Item = Form.Item

class DiscussModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////

    static propTypes = {
        objectCollection: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        items: null
    }

    ///////////////////////////////////////////////////////////////////

    UNSAFE_componentWillMount() {
        this.api_list_items()
    }

    componentDidMount() {

    }

    ///////////////////////////////////////////////////////////////////

    api_list_items = async () => {
        const { userCode } = this.props.user
        const { ObjectCollectionNid } = this.props.objectCollection
        this.setState({ loading: true })
        const result = await req_list_ccw_haviorLog('DISCUSS', ObjectCollectionNid)
        this.setState({ loading: false })

        // console.log(result)
        if (result.total > 0) {
            const source = result.data
            const items = []
            source.forEach(item => {
                items.push({ 'Uid': item.Uid, 'OperatorName': item.OperatorName, 'Description': item.Description, 'createDatetime': formateDate(item.RecordCreateDateTime), 'DelStatus': item.OperatorCode === userCode ? 'Y' : 'N' })
            });


            this.setState({ items })
           // console.log(this.state);
        } else {
            const items = []
            this.setState({ items })
        }
    }

    api_add_havior = async (item) => {
        const { token } = this.props.user
        await req_add_ccw_haviorLog(item, token)
        this.api_list_items()
    }

    api_del_havior = async (uid) => {
        const { token } = this.props.user
        await req_delete_ccw_haviorLog_discuss(uid, token)
        this.api_list_items()
    }


    // 操作互動處理 //////////////////////////////////////////////

    handle_delete_item = (item) => {
        console.log(item)
        this.api_del_havior(item.Uid)
    }

    handle_add_item = (values) => {
        const { Description } = values
        const { userCode, userName } = this.props.user
        const { ObjectCollectionNid } = this.props.objectCollection
        const data = {
            HaviorType: 'DISCUSS',
            OperatorCode: userCode,
            OperatorName: userName,
            ObjectCollectionNid: ObjectCollectionNid,
            Description: Description
        }
        this.api_add_havior(data)
    }

    ///////////////////////////////////////////////////////////////////

    render() {
        const { ObjectCollectionName } = this.props.objectCollection
        const { items } = this.state
        const { token } = this.props.user
        return (
            <>
                {items ? (<Card title={"[" + ObjectCollectionName + "]作品討論"}>
                    {items.map((item, index) => {
                        return (
                            <Card key={index} type="inner" title={item.createDatetime} extra={item.DelStatus === 'Y' ? (<button type="button" className="btn btn-outline-dark btn-sm" onClick={() => this.handle_delete_item(item)}><i className="fas fa-minus-square"></i><span style={{ marginLeft: '2px' }}> 刪除</span></button>) : ''}>
                                <span><i className="fas fa-user-alt"></i>{' '}{item.OperatorName}</span><span>：</span><span>{item.Description}</span>
                            </Card>
                        )
                    })}
                </Card>) : '尚無討論內容.......'}
                {token ?
                    (<>
                        <Divider orientation="left"><i className="far fa-comment-alt"></i> 對此作品感想：</Divider>
                        <Form
                            onFinish={this.handle_add_item}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Item
                                name="Description"
                                rules={[
                                    { required: true, message: '必須輸入內容' },
                                ]}
                            >
                                <Input placeholder='感想內容' />
                            </Item>
                            <Item >
                                <Button type="primary" htmlType="submit">發表</Button>
                            </Item>
                        </Form>
                    </>) : ''
                }
            </>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(DiscussModal)